import { HttpResponse } from '@/clients/http'

/** React Query wants a thrown error; the http client returns an envelope. */
export const unwrap = async <T>(request: Promise<HttpResponse<T>>): Promise<T> => {
  const res = await request
  if (!res.success || res.data === undefined) throw new Error(res.error?.message ?? 'Request failed')
  return res.data
}
